import React from 'react'
import ReactDOM from 'react-dom'
import Swiper, { Autoplay, Navigation, Pagination, Keyboard } from 'swiper'
import 'swiper/swiper-bundle.css'

import './product-card.scss'
import './section-card.scss'
import './sections.scss'
import './products.scss'
import './menu.scss'
import './element.scss'
import './filter/filter.scss'
import './baners/baners.scss'
import './sort.scss'
import './empty.scss'
import './styles.scss'

import Scroll from './../../../../../../js/classes/Scroll'
import Catalog from './../../../../../../js/classes/Catalog'
//import Mokka from './../../../../../../js/classes/Mokka'

//import ComponentIFrame from './../../../../../layouts/iframe/iframe.jsx'

import queryString from 'query-string'
import fslightbox from 'fslightbox'

//Отловить backspace переход назад и запуситть поиск по новому!!!!!!!!!

const catalogFilterNode = document.querySelector('.catalog__filter'),
isSaleComponent = catalogFilterNode ? catalogFilterNode.getAttribute('data-component') === 'catalog-sale' : false

const Filter = {
    getFilterProducts (cb, isReset=false) {
        let path = document.location.pathname.split('/')
        path.pop()
        path.shift()
    
        let bodyParams = Filter.catalogFilterGetUrl({
            path : path.join('/')
        }, isReset),
        filterParams = Filter.catalogFilterGetUrl({}, isReset)

        history.pushState({
            page_url : document.location.pathname,
        }, null, `${ document.location.pathname }${ filterParams }`)

        document.querySelector('.catalog').classList.add('catalog_loading')

        if (isSaleComponent) {
            document.location.reload()
            return true
        };
    
        fetch(CATALOG_COMPONENT_FETCH_URL + bodyParams)
        .then(r => r.text())
        .then((data) => {
            document.querySelector('.catalog').classList.remove('catalog_loading')

            if (cb) {
                cb(data)
            }
        })
    },

    catalogFilterGetUrl(_params={}, isReset=false) {
        const params = Object.assign(queryString.parse(location.search), _params),
        keys = Object.keys(params)

        if (isReset) {
            keys.forEach((key) => {
                if (key !== 'path') {
                    params[key] = null
                }
            })
        }

        params.cpage = null
    
        document.querySelectorAll('.catalog__filter .catalog__filter-item .select-ui__box, .catalog__sort .select-ui__box').forEach((selectBoxItem) => {
            var key = selectBoxItem.getAttribute('data-code'),
            value = selectBoxItem.value

            if (value === 'NULL' || value === '' || isReset) {
                params[key] = null
            } else {
                params[key] = value
            }
        })

        const filterUrl = queryString.stringifyUrl({
            url: '', 
            query: params
        }, {
            skipNull : true
        })
    
        return filterUrl
    },

    getProducts(isReset=false) {
        const parent = document.querySelector('.catalog__fetch')
    
        Filter.getFilterProducts((data) => {
            parent.innerHTML = data

            Scroll.scrollTo(parent, 300)

            //Set add favorite   !!!!!!!!!!!!!
            Filter.catalogFilterSetEvents()
            
            Catalog.setCatalogSmallImagesNav()
            Catalog.setYoutubeLinks()
            Catalog.setFavoriteEvents()
        }, isReset)
    },

    catalogFilterSetEvents(isButtons=true) {
        if (isButtons) {
            Catalog.setCatalogAddCartEvents()
        }

        document.querySelectorAll('.catalog__filter .catalog__filter-item .select-ui__box').forEach((selectBoxItem) => {
            selectBoxItem.addEventListener('change', (e) => {
                Filter.getProducts()
            })
        })

        document.querySelectorAll('.catalog__filter-submit .button_filter-submit, .catalog__empty .button_catalog-reset').forEach((resetButton) => {
            resetButton.addEventListener('click', (e) => {
                Filter.getProducts(true)
            })
        })

        document.querySelectorAll('.catalog__sort .select-ui__box').forEach((selectBoxItem) => {
            selectBoxItem.addEventListener('change', (e) => {
                Filter.getProducts()
            })
        })

        const buttonFilterShow = document.querySelector('.button_filter-show')

        if (buttonFilterShow) {
            buttonFilterShow.addEventListener('click', () => {
                const catalogFilterNode = document.querySelector('.catalog__filter')

                catalogFilterNode.classList.add('catalog__filter_show')
                buttonFilterShow.remove()
            })
        }
    },
}

Filter.catalogFilterSetEvents(false)

//BANERS SLIDER
const shopBanersContainer = document.querySelector('.shop-baners')

if (shopBanersContainer) {
    Swiper.use([ Autoplay, Navigation, Pagination, Keyboard ])

    const setBanerSlider = () => {
        if (shopBanersContainer.swiper) {
            shopBanersContainer.swiper.destroy()
        }

        const swiper = new Swiper(shopBanersContainer, {
            direction: 'horizontal',

            autoplay: true,
            delay: 4000,

            slidesPerView: 5,

            loop : true,
            
            navigation: {
                nextEl: '.shop-baners .swiper-button-next',
                prevEl: '.shop-baners .swiper-button-prev',
            },
            pagination: {
                el: '.shop-baners .swiper-pagination',
                clickable: true,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },

            on: {
                init() {
                    this.el.addEventListener('mouseenter', () => {
                        if (this && this.autoplay) {
                            this.autoplay.stop()
                        }
                    })

                    this.el.addEventListener('mouseleave', () => {
                        if (this && this.autoplay) {
                            this.autoplay.start()
                        }
                    })
                }
            },

            breakpointsBase : 'container',
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },

                380: {
                    slidesPerView: 2,
                },

                620: {
                    slidesPerView: 3,
                },

                840: {
                    slidesPerView: 4,
                },

                980: {
                    slidesPerView: 5,
                },
            }
        })
    }

    const setShopBanersWidth = () => {
        const shopBanerOuterNode = document.querySelector('.shop-baners-outer')

        shopBanerOuterNode.style.width = `0px`

        setTimeout(() => {            
            const width = document.querySelector('.catalog__content').clientWidth

            shopBanerOuterNode.style.width = `${ width }px`

            setBanerSlider()
        }, 0)
    }

    setShopBanersWidth()

    window.addEventListener('resize', setShopBanersWidth)

    setTimeout(() => {
        setBanerSlider()
    }, 0)
}

const buttonMenuShow = document.querySelector('.button_menu-show')

if (buttonMenuShow) {
    buttonMenuShow.addEventListener('click', () => {
        const catalogMenuNode = document.querySelector('.catalog__menu')

        catalogMenuNode.classList.add('catalog__menu_show')
        buttonMenuShow.remove()
    })
}

const buttonFilterShow = document.querySelector('.button_filter-show')

if (buttonFilterShow) {
    buttonFilterShow.addEventListener('click', () => {
        const catalogFilterNode = document.querySelector('.catalog__filter')

        catalogFilterNode.classList.add('catalog__filter_show')
        buttonFilterShow.remove()
    })
}

document.querySelectorAll('.product-card .product-card__navs').forEach((navsContainer) => {
    const parent = navsContainer.parentNode
    
    let intervalID = null

    const setAutoSlide = (onlyClear=false) => {
        clearInterval(intervalID)

        if (!onlyClear) {
            intervalID = setInterval(() => {
                const navButton = navsContainer.querySelector('.product-card__nav_next')

                if (navButton) navButton.click()
            }, 1500)
        }
    }

    parent.addEventListener('mouseover', (e) => {
        if (!e.target?.classList?.contains('product-card__nav')) {
            setAutoSlide()
        } else {
            setAutoSlide(true)
        }
    })

    parent.addEventListener('mouseout', () => {
        setAutoSlide(true)
    })

    navsContainer.addEventListener('mouseover', () => {
        setAutoSlide(true)
    })
})

/*
document.querySelectorAll('.happy__price-module').forEach((button) => {
    button.addEventListener('click', (e) => {
        Mokka.registration((err, res) => {
            if (err) {
                console.error(err)
            } else {
                const iframeContainer = document.getElementById('root-iframe-container')

                if (iframeContainer) {
                    const handleClose = () => {
                        ReactDOM.unmountComponentAtNode(iframeContainer)
                    }
                    
                    const component = <ComponentIFrame
                        src={ res }
                        onClose={ handleClose }
                    />

                    ReactDOM.render(
                        component,
                        iframeContainer
                    )
                }
            }
        })
    })
})

document.querySelectorAll('.happy__price-module__modal-trigger').forEach((button) => {
    button.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        document.querySelector('.happy__price-module-modal').classList.add('open')        

        return false
    })

    document.querySelector('.happy__price-module-modal__backdrop').addEventListener('click', () => {
        document.querySelector('.happy__price-module-modal').classList.remove('open')
    })

    document.querySelector('.happy__price-module-modal__modal-close').addEventListener('click', () => {
        document.querySelector('.happy__price-module-modal').classList.remove('open')
    })
})
*/